import { render, staticRenderFns } from "./WorkspacesPage.vue?vue&type=template&id=75fd1a2c&"
import script from "./WorkspacesPage.vue?vue&type=script&lang=ts&"
export * from "./WorkspacesPage.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspacesPage.vue?vue&type=style&index=0&id=75fd1a2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports